// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@awc/Overrides/Components/OrderUploadErrorsModal";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderUploadErrorsModalStyles.tableWrapper = {
    css: css`
        display: block;
        width: 100%;
        overflow: auto;
    `,
};

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: end;
        margin-top: 21px;
    `,
};

orderUploadErrorsModalStyles.cancelUploadButton = {
    variant: "secondary",
    sizeVariant: "small",
};
orderUploadErrorsModalStyles.continueUploadButton = {
    sizeVariant: "small",
    css: css`
        margin-left: 10px;
    `,
};

orderUploadErrorsModalStyles.tableHead =
    orderUploadErrorsModalStyles.rowNumberHeader =
    orderUploadErrorsModalStyles.itemNumberHeader =
    orderUploadErrorsModalStyles.qtyHeader =
    orderUploadErrorsModalStyles.unitOfMeasureHeader =
    orderUploadErrorsModalStyles.reasonHeader =
        {
            css: css`
                background: ${color("common.white")};
            `,
        };

orderUploadErrorsModalStyles.tableRow = {
    css: css`
        &,
        &:nth-child(even) {
            background: ${color("common.ui18")};
        }
        & > td,
        && ${TypographyStyle} {
            color: ${color("danger")};
        }
        & > td {
            border: none;
        }
        border-left: 1px solid ${color("common.ui19")};
        border-right: 1px solid ${color("common.ui19")};
        border-bottom: 1px solid ${color("common.ui19")};
    `,
};

orderUploadErrorsModalStyles.titleWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 13px;
    `,
};

orderUploadErrorsModalStyles.descriptionText = {
    variant: "h2",
    css: css`
        margin: 0;
    `,
};
